export default __webpack_public_path__ + "static/halloween-01-3a2506d5fae339d8bc824667fb81558f.jpg";